var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.967,
    height: 21.5,
    viewBox: "0 0 22.967 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44500",
    "data-name": "Group 44500",
    transform: "translate(-0.25 -2.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23927",
    "data-name": "Group 23927",
    transform: "translate(1 3.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32636",
    "data-name": "Path 32636",
    d: "M9.963,13.255H6.074A5.285,5.285,0,0,0,1,18.728V19.9c1.1-.144,7.7,0,7.7,0",
    transform: "translate(-1 -3.776)",
    fill: "none",
    stroke: "#ef8a50",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32637",
    "data-name": "Path 32637",
    d: "M12.864,4.718A3.719,3.719,0,1,1,9.145,1,3.718,3.718,0,0,1,12.864,4.718Z",
    transform: "translate(-2.127 -1)",
    fill: "none",
    stroke: "#ef8a50",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32635",
    "data-name": "Path 32635",
    d: "M19.69,13.255a6.649,6.649,0,1,0,2.6.525A6.614,6.614,0,0,0,19.69,13.255Z",
    transform: "translate(-4.89 -6.592)",
    fill: "none",
    stroke: "#ef8a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    y2: 4.465,
    transform: "translate(13.328 11.309)",
    fill: "none",
    stroke: "#ef8a50",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    y2: 4.465,
    transform: "translate(16.768 11.309)",
    fill: "none",
    stroke: "#ef8a50",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction2);
export default __webpack_public_path__ + "static/media/action_2.9d4775bde70e8c1d4637978f9bfd5661.svg";
export { ForwardRef as ReactComponent };